import React from 'react';
import FormItem from '@/components/ui/FormItem';
import Select from '@/components/ui/Select';
import { useSector } from '@/components/views/Resolution886/components/Form/_hooks/useSector';
import type { FormItemProps } from '@/components/views/Resolution886/types';

interface SectorFormItemProps extends FormItemProps {
	fieldName?: string | string[];
}

export function SectorFormItem({ fieldName, required, labelCol }: Readonly<SectorFormItemProps>): JSX.Element {
	const { isFetching, items, sectorId, isDisabled, handleClearSector, handleSectorSelect } = useSector({
		fieldName
	});

	return (
		<FormItem
			label="Sector"
			name={fieldName}
			required={required}
			labelCol={labelCol}
			requiredMessage="Please select a sector"
		>
			<Select
				allowClear
				options={items}
				value={sectorId}
				loading={isFetching}
				disabled={isDisabled}
				onClear={handleClearSector}
				onChange={handleSectorSelect}
				placeholder="Select a sector"
			/>
		</FormItem>
	);
}
